import { get } from "lodash";

export const DRAFT_ERRORS = {
  DRAFT_CONFLICT: "DRAFT_CONFLICT",
  SCREEN_VERSION_PUBLISHED: "SCREEN_VERSION_PUBLISHED",
};

export const errorCodeOf = (error, codes = []) => {
  const candidates = [
    get(error, "graphQLErrors.0.message"),
    get(error, "graphQLErrors.0.extensions.exception.message"),
    get(error, "message"),
  ].filter(Boolean);
  for (const candidate of candidates) {
    const code = codes.find((item) =>
      new RegExp(`\\b${item}\\b`).test(String(candidate)),
    );
    if (code) return code;
  }
  return null;
};

export const draftErrorOf = (error) =>
  errorCodeOf(error, Object.values(DRAFT_ERRORS));
